import { List } from "antd";
import { NotificationListItemProps } from ".";
import { IoIosWarning } from "react-icons/io";
import {
  StyledNotificationDescription,
  StyledNotificationTitle,
  StyledNotifyListItem,
} from "./index.styled";
import { useTypedDispatch } from "@lib/redux";
import { StyledFlex } from "@lib/components/MiniComponents/Table/index.styled";
import { ActionButton } from "@lib/components/MiniComponents/Buttons";
import { fetchNotifications } from "@lib/redux/slices/notifications";
import { AppAvatar } from "@lib/components/AppComponents";

export default function ErrorEvent(props: NotificationListItemProps) {
  const { notification } = props;
  const dispatch = useTypedDispatch();

  const payload = notification.payload as { error: string };

  return (
    <StyledNotifyListItem className="item-hover is-error" isError>
      <List.Item.Meta
        title={
          <StyledFlex>
            <StyledNotificationTitle>Error</StyledNotificationTitle>
            <ActionButton
              type="refresh"
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                dispatch(fetchNotifications({ page: 1, limit: 50 }));
              }}
            />
          </StyledFlex>
        }
        description={
          <StyledNotificationDescription>
            {payload.error}
          </StyledNotificationDescription>
        }
        avatar={<AppAvatar icon={<IoIosWarning />} size="small" />}
      />
    </StyledNotifyListItem>
  );
}
